import { memo } from "react";
import { ScrollView } from "react-native-gesture-handler";
import { CenteredScrollViewProps } from "./types";

const CenteredScrollView = ({ children, ...rest }: CenteredScrollViewProps) => {
	return (
		<ScrollView centerContent {...rest}>
			{children}
		</ScrollView>
	);
};
export default memo(CenteredScrollView);
